<template>
  <div class="info">
    <p class="info__label">{{ label }}:</p>

    <slot>
      <div class="text-content" v-html="sanitizeText" />
    </slot>
  </div>
</template>

<script>
import { minus, sanitizeHtml } from '@/utils/string'

export default {
  name: 'InfoText',
  props: {
    label: {
      type: String,
      default: ''
    },
    text: {
      type: [String, Number, Array, Boolean, Object],
      default: '-'
    },
    join: {
      type: String,
      default: '/'
    },
    isHandbook: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentText () {
      if (this.isHandbook) {
        return minus(this.text?.name)
      }

      if (Array.isArray(this.text)) {
        return this.text
          .map(minus)
          .join(this.join)
      }

      return minus(this.text)
    },

    sanitizeText () {
      return sanitizeHtml(this.currentText)
    }
  }
}
</script>
